import { IUserInfo } from "../DataStorage/IUserInfo";
import { BuilderTypes } from "./BuilderTypes";

export interface IBuilderStorageCallback {
    builderChanged(
        user: IUserInfo,
        builderProjectId: string | undefined,
        builderId: string,
        builderType: BuilderTypes
    ): void;

    builderAdded(
        user: IUserInfo,
        builderProjectId: string | undefined,
        builderId: string,
        builderType: BuilderTypes
    ): void;

    builderRemoved(
        user: IUserInfo,
        builderProjectId: string | undefined,
        builderId: string,
        builderType: BuilderTypes
    ): void;

    builderProjectChanged(user: IUserInfo, builderProjectId: string): void;

    builderProjectAdded(user: IUserInfo, builderProjectId: string): void;

    builderProjectRemoved(user: IUserInfo, builderProjectId: string): void;

    changeSetMerged(user: IUserInfo, changeSetName: string): void;

    changeSetAdded(user: IUserInfo, changeSetName: string): void;

    changeSetUpdated(user: IUserInfo, changeSetName: string): void;

    changeSetDeleted(user: IUserInfo, changeSetName: string): void;
}

export class BuilderStorageCallback {
    static callbacks: IBuilderStorageCallback[] = [];

    static registerCallback(callback: IBuilderStorageCallback): void {
        this.callbacks.push(callback);
    }

    static getCallbacks(): IBuilderStorageCallback[] {
        return this.callbacks;
    }
}
